import Icon from '../components/Icon.vue'

Icon.register({"angle-double-down":{"width":320,"height":512,"paths":[{"d":"M143 256.3L7 120.3C-2.4 110.9-2.4 95.7 7 86.4L29.6 63.8C39 54.4 54.2 54.4 63.5 63.8L159.9 160.2 256.3 63.8C265.7 54.4 280.9 54.4 290.2 63.8L313 86.3C322.4 95.7 322.4 110.9 313 120.2L177 256.2C167.6 265.7 152.4 265.7 143 256.3zM177 448.3L313 312.3C322.4 302.9 322.4 287.7 313 278.4L290.4 255.8C281 246.4 265.8 246.4 256.5 255.8L160 352.1 63.6 255.7C54.2 246.3 39 246.3 29.7 255.7L7 278.3C-2.4 287.7-2.4 302.9 7 312.2L143 448.2C152.4 457.7 167.6 457.7 177 448.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/angle-double-down.js
// module id = null
// module chunks = 